import Footer from "components/Footers/Footer";
import Navbar from "components/Navbars/AuthNavbar";
import React, { useEffect, useRef, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import BASE_URL from "components/BaseUrl/apiConfig";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCoffee, faMapLocationDot } from "@fortawesome/free-solid-svg-icons";
import MapSearch from "../Admin/MapSearch";
import { Link } from "react-router-dom";

function MyLocations() {
  const [locations, setLocations] = useState([]);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  // const [editingLocation, setEditingLocation] = useState(null);
  const [editId, setEditId] = useState(null);
  const formikRef = useRef(null);

  const userId =
    JSON.parse(localStorage.getItem("userData") || "{}").userId || "";

  const [initialValues, setInitialValues] = useState({
    ID: editId,
    title: "",
    fullAddress: "",
    latitude: "",
    longitude: "",
    addressDescription: "",
    userID: userId,
  });

  const validationSchema = Yup.object({
    title: Yup.string().required("Title is required."),
    fullAddress: Yup.string().required("Full address is required."),
    latitude: Yup.number()
      .typeError("Latitude must be a number.")
      .required("Latitude is required."),
    longitude: Yup.number()
      .typeError("Longitude must be a number.")
      .required("Longitude is required."),
  });

  const handleSubmit = (data, { resetForm }) => {
    console.log("data", data);
    async function InsertOrUpdateLocation(data) {
      try {
        const url = isEditing
          ? `${BASE_URL}/api/Locations/UpdateLocation`
          : `${BASE_URL}/api/Locations/InsertLocation`;

        const response = await fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        });

        if (!response.ok)
          throw new Error(`HTTP error! status: ${response.status}`);

        const { msg } = await response.json();
        resetForm();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: msg,
        });

        setIsEditing(false);
        // setEditingLocation(null);
        LoadDate();
      } catch (error) {
        console.error("Error saving location:", error.message);
      }
    }

    InsertOrUpdateLocation(data);
  };

  const UserID =
    JSON.parse(localStorage.getItem("userData") || "{}").userId || "";

  async function LocationsByUserID(UserID) {
    try {
      const response = await fetch(
        `${BASE_URL}/api/Locations/LocationsByUserID?UserID=${UserID}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);

      const locations = await response.json();
      return locations;
    } catch (error) {
      console.error("Error fetching locations:", error.message);
    }
  }

  async function getLocationById(id) {
    try {
      const response = await fetch(
        `${BASE_URL}/api/Locations/GetLocationByID?ID=${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);

      const location = await response.json();
      return location;
    } catch (error) {
      console.error("Error fetching location by ID:", error.message);
    }
  }

  async function deleteLocationById(id) {
    try {
      const response = await fetch(
        `${BASE_URL}/api/Locations/DeleteLocationsByID?ID=${id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);

      const { success, msg } = await response.json();
      if (success) {
        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: msg,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed!",
          text: "Failed to delete location.",
        });
      }
    } catch (error) {
      console.error("Error deleting location:", error.message);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while deleting the location.",
      });
    }
  }

  useEffect(() => {
    LoadDate();
  }, []);

  function LoadDate() {
    LocationsByUserID(UserID)
      .then((locations) => {
        setLocations(locations);
      })
      .catch((error) => {
        console.log("Failed to fetch locations:", error.message);
      });
    setInitialValues({
      ID: "0",
      title: "",
      fullAddress: "",
      latitude: "",
      longitude: "",
      addressDescription: "",
      userID: userId,
    });
  }

  async function editLocation(id) {
    try {
      const location = await getLocationById(id);

      console.log(location);
      // Update state for editing
      setEditId(location.id);
      setIsEditing(true);
      setLatitude(location.latitude);
      setLongitude(location.longitude);

      // Update initial values with the location data
      setInitialValues({
        ID: location.id || "0",
        title: location.title || "",
        fullAddress: location.fullAddress || "",
        latitude: location.latitude || "",
        longitude: location.longitude || "",
        addressDescription: location.addressDescription || "",
        userID: userId,
      });
    } catch (error) {
      console.error("Error editing location:", error.message);
    }
  }

  function confirmAndDeleteLocation(id) {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to undo this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteLocationById(id).then(() => {
          Swal.fire("Deleted!", "The location has been deleted.", "success");
          LoadDate();
        });
      }
    });
  }

  const clearform = () => {
    setIsEditing(false);
    if (formikRef.current) {
      formikRef.current.resetForm();
    }
    setInitialValues({
      ID: "0",
      title: "",
      fullAddress: "",
      latitude: "",
      longitude: "",
      addressDescription: "",
      userID: userId,
    });
  };

  const isNumberKey = (evt) => {
    const charCode = evt.which ? evt.which : evt.keyCode;
    if (
      charCode !== 46 &&
      charCode > 31 &&
      (charCode < 48 || charCode > 57) &&
      charCode !== 190
    ) {
      evt.preventDefault();
    }
  };

  const handleLocationSelect = (location) => {
    console.log("Selected Location:", location);
    // You can use this data to perform further actions such as updating state, sending data to an API, etc.
  };

  // Callback function to update the parent state when location changes
  const handleLocationChange = (location) => {
    setLatitude(location.lat);
    setLongitude(location.lng);
    formikRef.current.setFieldValue("latitude", String(location.lat));
    formikRef.current.setFieldValue("longitude", String(location.lng));
  };

  return (
    <>
      <Navbar />
      <div className="min-h-content-minvh">
        <div className="mx-auto px-6">
          <div className="flex items-center justify-between py-2">
            <h1 className="text-2xl font-bold">My Locations</h1>
            <div>
              <a
                href="/showLocationMap"
                className="bg-blue-500 text-white text-2xl rounded-md px-2 py-1 ml-2"
                // title="Locations on Map"
              >
                <FontAwesomeIcon icon={faMapLocationDot} />
              </a>
            </div>
          </div>
          {/* <p>Latitude: {latitude}</p>
          <p>Longitude: {longitude}</p> */}

          <Formik
            innerRef={formikRef}
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize={true}
          >
            <Form className="grid grid-cols-4 md:grid-cols-6 xl:grid-cols-12 gap-4">
              {/* <div className="col-span-2 d-none">
                <Field
                  id="id"
                  name="id"
                  className="w-full border focus:outline-none focus:ring focus:border-blue-300"
                />
              </div> */}
              <div className="col-span-2">
                <Field
                  type="text"
                  id="title"
                  name="title"
                  placeholder="Title"
                  maxLength="28"
                  className="form-control custom-height !border-2 border-blueGray-300 rounded-sm"
                />
                <ErrorMessage
                  name="title"
                  component="p"
                  className="text-red-500 text-sm mt-1"
                />
              </div>

              <div className="col-span-2">
                <Field
                  type="text"
                  id="fullAddress"
                  name="fullAddress"
                  placeholder="Address"
                  maxLength="200"
                  className="form-control custom-height !border-2 border-blueGray-300 rounded-sm"
                />
                <ErrorMessage
                  name="fullAddress"
                  component="p"
                  className="text-red-500 text-sm mt-1"
                />
              </div>

              <div className="col-span-2">
                <Field
                  type="text"
                  id="addressDescription"
                  maxLength="500"
                  name="addressDescription"
                  placeholder="Remarks"
                  className="form-control custom-height !border-2 border-blueGray-300 rounded-sm"
                />
              </div>

              <div className="col-span-2">
                <div className="grid grid-cols-4 gap-4">
                  <div className="col-span-2">
                    <Field
                      type="text"
                      id="latitude"
                      name="latitude"
                      maxLength="100"
                      placeholder="Latitude"
                      onKeyDown={isNumberKey}
                      className="form-control custom-height !border-2 border-blueGray-300 rounded-sm"
                    />
                    <ErrorMessage
                      name="latitude"
                      component="p"
                      className="text-red-500 text-sm mt-1"
                    />
                  </div>
                  <div className="col-span-2">
                    <Field
                      type="text"
                      id="longitude"
                      name="longitude"
                      maxLength="100"
                      placeholder="Longitude"
                      onKeyDown={isNumberKey}
                      className="form-control custom-height !border-2 border-blueGray-300 rounded-sm"
                    />
                    <ErrorMessage
                      name="longitude"
                      component="p"
                      className="text-red-500 text-sm mt-1"
                    />
                  </div>
                </div>
              </div>

              <div className="col-span-4">
                <div className="grid grid-cols-3 gap-2">
                  <MapSearch
                    initialLatitude={latitude}
                    initialLongitude={longitude}
                    onLocationChange={handleLocationChange}
                    className="col-span-1 !w-full bg"
                  />
                  <button
                    type="submit"
                    className="col-span-1 bg-blue-500 !w-full text-white font-medium py-2 !h-9 rounded-sm focus:outline-none focus:ring focus:ring-blue-300 custom-button "
                  >
                    {isEditing ? "Update Location" : "Add Location"}
                  </button>
                  <button
                    type="button"
                    className="!bg-red-500 col-span-1 py-2 !w-full font-medium rounded-sm custom-button !h-9 text-white"
                    onClick={clearform}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </Form>
          </Formik>
        </div>

        <div className="mx-auto bg-white px-6">
          <div className="overflow-x-auto">
            {/* <table className="table-auto border-collapse">
              <thead>
                <tr className="bg-sky-500 text-white">
                  <th className="border-gray-300 px-4 py-2 w-1/6">Title</th>
                  <th className="border-gray-300 px-4 py-2 w-1/6">Address</th>
                  <th className="border-gray-300 px-4 py-2 w-1/6">Latitude</th>
                  <th className="border-gray-300 px-4 py-2 w-1/6">Longitude</th>
                  <th className="border-gray-300 px-4 py-2 w-1/6">
                    Description
                  </th>
                  <th className="border-gray-300 px-4 py-2 w-1/6 flex justify-end">
                    Actions
                  </th>
                </tr>
              </thead>

              <tbody>
                {locations.length > 0 &&
                  locations.map((location) => (
                    <tr key={location.id} className="cust-row">
                      <td className=" cell py-1 px-4">{location.title}</td>
                      <td className=" cell py-1 px-4">
                        {location.fullAddress}
                      </td>
                      <td className=" cell py-1 px-4">{location.latitude}</td>
                      <td className=" cell py-1 px-4">{location.longitude}</td>
                      <td className=" cell py-1 px-4">
                        {location.addressDescription}
                      </td>
                      <td className=" cell py-1 px-4 flex justify-end">
                        <img
                          src={require("assets/img/Editicon.png")}
                          alt="Edit"
                          title="Edit"
                          className="mr-2 cursor-pointer"
                          style={{ width: "20px" }}
                          onClick={() => editLocation(location.id)}
                        />

                        <img
                          src={require("assets/img/deleteicon.png")}
                          alt="Delete"
                          title="Delete"
                          className="cursor-pointer"
                          style={{ width: "20px" }}
                          onClick={() => confirmAndDeleteLocation(location.id)}
                        />
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table> */}

            <div className="min-w-[1020px]">
              <div className="grid grid-cols-12 gap-4 bg-sky-500 text-white">
                <div className="col-span-2 border-gray-300 px-2 py-2">
                  Title
                </div>
                <div className="col-span-2 border-gray-300 px-2 py-2">
                  Address
                </div>
                <div className="col-span-2 border-gray-300 px-2 py-2">
                  Remarks
                </div>
                <div className="col-span-2 border-gray-300 px-2 py-2">
                  Latitude
                </div>
                <div className="col-span-2 border-gray-300 px-2 py-2">
                  Longitude
                </div>
                <div className="col-span-2 border-gray-300 px-2 py-2 text-right">
                  Actions
                </div>
              </div>
              {locations.length > 0 &&
                locations.map((location) => (
                  <div
                    key={location.id}
                    className="grid grid-cols-12 gap-4 items-center border-t border-gray-300 bg-sky-100 hover:bg-gray-100"
                  >
                    <div className="col-span-2 px-2 py-2">{location.title}</div>
                    <div className="col-span-2 px-2 py-2">
                      {location.fullAddress}
                    </div>
                    <div className="col-span-2 px-2 py-2">
                      {location.addressDescription}
                    </div>
                    <div className="col-span-2 px-2 py-2">
                      {location.latitude}
                    </div>
                    <div className="col-span-2 px-2 py-2">
                      {location.longitude}
                    </div>
                    <div className="col-span-2 px-2 py-2 flex justify-end">
                      <img
                        src={require("assets/img/Editicon.png")}
                        alt="Edit"
                        title="Edit"
                        className="mr-2 cursor-pointer"
                        style={{ width: "20px" }}
                        onClick={() => editLocation(location.id)}
                      />
                      <Link to={`viewlocation/${location.id}`}>
                        <FontAwesomeIcon
                          icon={faMapLocationDot}
                          className="cursor-pointer mr-2"
                          title="View"
                          style={{
                            width: "20px",
                            color: "#1e97fe",
                            fontSize: "19px",
                          }}
                        />
                      </Link>

                      <img
                        src={require("assets/img/deleteicon.png")}
                        alt="Delete"
                        title="Delete"
                        className="cursor-pointer"
                        style={{ width: "20px" }}
                        onClick={() => confirmAndDeleteLocation(location.id)}
                      />
                    </div>
                  </div>
                ))}
            </div>

            {locations.length === 0 && (
              <div className="w-full text-center mt-3">
                <p className="text-gray-500">No locations added yet.</p>
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default MyLocations;
